/** Used to color the significance of the current outage */
export enum StatuspageImpact {
	None = 'none',
	Minor = 'minor',
	Major = 'major',
	Critical = 'critical',
}
